import React from "react";
import { Modal } from "react-bootstrap";
import { Heading6 } from "../../widgets";
import AllUtilizationChart from "./AllUtilizationChart";

const AllUtilizationModal = (props) => {
  const { show, onHide, searchParams } = props;

  return (
    <Modal show={show} onHide={onHide} className="modal-fs vw-100">
      <Modal.Header closeButton onClick={onHide}>
        <Modal.Title>
          <Heading6>
            <span style={{ color: "grey" }}>Utilization % | All</span>
          </Heading6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-0">
        <AllUtilizationChart searchParams={searchParams} />
      </Modal.Body>
    </Modal>
  );
};

export default AllUtilizationModal;
